const models = {
  tender: [
    {
      title: 'Project initiation',
      actions: [
        {
          title: 'Identify stakeholders',
          type: 'To-do',
        },
        {
          title: 'Project team formulated',
          type: 'Event',
        },
        {
          title: 'Kick off meeting',
          type: 'Meeting',
        },
        {
          title: 'Defining roles & agreeing objectives, timescales and scope',
          type: 'Milestone',
        },
      ],
    },
    {
      title: 'Research',
      actions: [
        {
          title: 'Market research conducted',
          type: 'To-do',
        },
        {
          title: 'Spend analysis – current total cost of ownership baseline',
          type: 'To-do',
        },
        {
          title: 'Supplier analysis',
          type: 'To-do',
        },
        {
          title: 'Produce RFI',
          type: 'To-do',
        },
        {
          title: 'Run RFI',
          type: 'Event',
        },
      ],
    },
    {
      title: 'RFP',
      actions: [
        {
          title: 'Produce RFP',
          type: 'To-do',
        },
        {
          title: 'Gain stakeholder input',
          type: 'To-do',
        },
        {
          title: 'Select suppliers',
          type: 'Event',
        },
        {
          title: 'Issue NDAs',
          type: 'To-do',
        },
        {
          title: 'Sign off RFP',
          type: 'Milestone',
        },
        {
          title: 'Issue RFP',
          type: 'Event',
        },
        {
          title: 'Q&A',
          type: 'To-do',
        },
        {
          title: 'RFP responses',
          type: 'Event',
        },
        {
          title: 'Presentations',
          type: 'Event',
        },
        {
          title: 'RFP Evaluation',
          type: 'Event',
        },
      ],
    },
    {
      title: 'Downselect',
      actions: [
        {
          title: 'Produce recommendations',
          type: 'To-do',
        },
        {
          title: 'Internal sign off',
          type: 'Milestone',
        },
        {
          title: 'Notify suppliers',
          type: 'Event',
        },
      ],
    },
    {
      title: 'Negotiation',
      actions: [
        {
          title: 'Plan negotiation',
          type: 'To-do',
        },
        {
          title: 'Commercial negotiation',
          type: 'Event',
        },
        {
          title: 'Final supplier proposal submissions',
          type: 'Event',
        },
      ],
    },
    {
      title: 'Contractual',
      actions: [
        {
          title: 'Agree participating suppliers',
          type: 'To-do',
        },
        {
          title: 'Legal review of supplier submission',
          type: 'Event',
        },
        {
          title: 'Legal negotiation',
          type: 'Event',
        },
        {
          title: 'Agree final contractual position',
          type: 'Milestone',
        },
      ],
    },
    {
      title: 'Award',
      actions: [
        {
          title: 'Agree recommendation',
          type: 'To-do',
        },
        {
          title: 'Internal sign off',
          type: 'Milestone',
        },
        {
          title: 'Close remaining negotiation points',
          type: 'To-do',
        },
        {
          title: 'Sign contract',
          type: 'Milestone',
        },
        {
          title: 'Notify unsuccessful suppliers',
          type: 'Event',
        },
      ],
    },
    {
      title: 'Implementation',
      actions: [
        {
          title: 'Record benefits',
          type: 'Event',
        },
        {
          title: 'Contract onboarded',
          type: 'Milestone',
        },
        {
          title: 'Agree governance approach',
          type: 'To-do',
        },
        {
          title: 'Post Implementation Review meeting',
          type: 'Meeting',
        },
      ],
    },
  ],
  contractrenewal: [
    {
      title: 'Project initiation',
      actions: [
        {
          title: 'Identify stakeholders',
          type: 'To-do',
        },
        {
          title: 'Project team formulated',
          type: 'Event',
        },
        {
          title: 'Kick off meeting',
          type: 'Meeting',
        },
        {
          title: 'Defining roles & agreeing objectives, timescales and scope',
          type: 'Milestone',
        },
      ],
    },
    {
      title: 'Research',
      actions: [
        {
          title: 'Market research conducted',
          type: 'To-do',
        },
        {
          title: 'Spend analysis – current total cost of ownership baseline',
          type: 'To-do',
        },
        {
          title: 'Supplier analysis',
          type: 'To-do',
        },
      ],
    },
    {
      title: 'Approach',
      actions: [
        {
          title: 'Produce recommendation',
          type: 'To-do',
        },
        {
          title: 'Internal approval to renew supplier',
          type: 'Milestone',
        },
        {
          title: 'Consider leverage points and other options',
          type: 'To-do',
        },
      ],
    },
    {
      title: 'Negotiation',
      actions: [
        {
          title: 'Plan negotiation',
          type: 'To-do',
        },
        {
          title: 'Commercial negotiation',
          type: 'Event',
        },
        {
          title: 'Final supplier proposal submissions',
          type: 'Event',
        },
      ],
    },
    {
      title: 'Contractual',
      actions: [
        {
          title: 'Legal review of supplier submission',
          type: 'Event',
        },
        {
          title: 'Legal negotiation',
          type: 'Event',
        },
        {
          title: 'Agree final contractual position',
          type: 'Milestone',
        },
      ],
    },
    {
      title: 'Award',
      actions: [
        {
          title: 'Agree recommendation',
          type: 'To-do',
        },
        {
          title: 'Internal sign off',
          type: 'Milestone',
        },
        {
          title: 'Close remaining negotiation points',
          type: 'To-do',
        },
        {
          title: 'Sign contract',
          type: 'Milestone',
        },
      ],
    },
    {
      title: 'Implementation',
      actions: [
        {
          title: 'Record benefits',
          type: 'Event',
        },
        {
          title: 'Contract onboarded',
          type: 'Milestone',
        },
        {
          title: 'Agree governance approach',
          type: 'To-do',
        },
        {
          title: 'Post Implementation Review meeting',
          type: 'Meeting',
        },
      ],
    },
  ],
  negotiation: [
    {
      title: 'Project initiation',
      actions: [
        {
          title: 'Identify stakeholders',
          type: 'To-do',
        },
        {
          title: 'Project team formulated',
          type: 'Event',
        },
        {
          title: 'Kick off meeting',
          type: 'Meeting',
        },
        {
          title: 'Defining roles & agreeing objectives, timescales and scope',
          type: 'Milestone',
        },
      ],
    },
    {
      title: 'Research',
      actions: [
        {
          title: 'Market research conducted',
          type: 'To-do',
        },
        {
          title: 'Spend analysis – current total cost of ownership baseline',
          type: 'To-do',
        },
        {
          title: 'Supplier analysis',
          type: 'To-do',
        },
      ],
    },
    {
      title: 'Supplier proposals',
      actions: [
        {
          title: 'Select supplier(s)',
          type: 'Event',
        },
        {
          title: 'Issue NDAs',
          type: 'To-do',
        },
      ],
    },
    {
      title: 'Negotiation',
      actions: [
        {
          title: 'Plan negotiation',
          type: 'To-do',
        },
        {
          title: 'Commercial negotiation',
          type: 'Event',
        },
        {
          title: 'Final supplier proposal submissions',
          type: 'Event',
        },
      ],
    },
    {
      title: 'Contractual',
      actions: [
        {
          title: 'Legal review of contracts',
          type: 'To-do',
        },
        {
          title: 'Legal negotiation',
          type: 'Event',
        },
        {
          title: 'Agree final contractual position',
          type: 'Milestone',
        },
      ],
    },
    {
      title: 'Award',
      actions: [
        {
          title: 'Agree supplier position',
          type: 'To-do',
        },
        {
          title: 'Internal sign off',
          type: 'Milestone',
        },
        {
          title: 'Close remaining negotiation points',
          type: 'To-do',
        },
        {
          title: 'Sign contract',
          type: 'Milestone',
        },
      ],
    },
    {
      title: 'Implementation',
      actions: [
        {
          title: 'Record benefits',
          type: 'Event',
        },
        {
          title: 'Contract onboarded',
          type: 'Milestone',
        },
        {
          title: 'Agree governance approach',
          type: 'To-do',
        },
        {
          title: 'Post Implementation Review meeting',
          type: 'Meeting',
        },
      ],
    },
  ],
  exit: [
    {
      title: 'Project initiation',
      actions: [
        {
          title: 'Identify stakeholders',
          type: 'To-do',
        },
        {
          title: 'Project team formulated',
          type: 'Event',
        },
        {
          title: 'Kick off meeting',
          type: 'Meeting',
        },
        {
          title: 'Defining roles & agreeing objectives, timescales and scope',
          type: 'Milestone',
        },
      ],
    },
    {
      title: 'Research',
      actions: [
        {
          title: 'Market research conducted',
          type: 'To-do',
        },
        {
          title: 'Spend analysis – current total cost of ownership baseline',
          type: 'To-do',
        },
        {
          title: 'Supplier analysis - review current exit plan',
          type: 'To-do',
        },
        {
          title: 'Legal review of contract and position',
          type: 'To-do',
        },
      ],
    },
    {
      title: 'Approach',
      actions: [
        {
          title: 'Consider risks and plan to mitigate',
          type: 'To-do',
        },
        {
          title: 'Produce recommendation',
          type: 'To-do',
        },
        {
          title: 'Internal approval to exit supplier',
          type: 'Event',
        },
        {
          title: 'New project initiated to replace supplier',
          type: 'Event',
        },
      ],
    },
    {
      title: 'Exit',
      actions: [
        {
          title: 'Contract manager and escalation points for exit confirmed',
          type: 'To-do',
        },
        {
          title: 'Termination letter written',
          type: 'To-do',
        },
        {
          title: 'Termination letter served to supplier',
          type: 'Event',
        },
        {
          title: 'Supplier exited',
          type: 'Milestone',
        },
        {
          title: 'Continue to manage exit plan to completion',
          type: 'To-do',
        },
      ],
    },
  ],
  processreview: [
    {
      title: 'Initiation',
      actions: [
        {
          title: 'Review current state processes',
          type: 'To-do',
        },
        {
          title: 'Identify pain points or areas for improvement',
          type: 'To-do',
        },
        {
          title: 'Identify key stakeholder team – all impacted areas',
          type: 'To-do',
        },
        {
          title: 'Agree key objectives / timelines',
          type: 'To-do',
        },
      ],
    },
    {
      title: 'Research',
      actions: [
        {
          title: 'Research best practice',
          type: 'To-do',
        },
        {
          title: 'Speak to peers on their approach',
          type: 'To-do',
        },
        {
          title: 'Understand legal / statutory obligations',
          type: 'To-do',
        },
        {
          title: 'Interview stakeholders',
          type: 'To-do',
        },
        {
          title: 'Consider organisational culture – what has worked?',
          type: 'To-do',
        },
      ],
    },
    {
      title: 'Document to-be process',
      actions: [
        {
          title:
            'Map out end-to-end process and touchpoints on other processes',
          type: 'To-do',
        },
        {
          title: 'Create or update process documentation',
          type: 'To-do',
        },
        {
          title: 'Produce communications plan',
          type: 'To-do',
        },
        {
          title: 'Produce recommendation',
          type: 'To-do',
        },
        {
          title: 'Get exec sign-off to approach',
          type: 'To-do',
        },
      ],
    },
    {
      title: 'Implementation',
      actions: [
        {
          title: 'Finalise documentation for release',
          type: 'To-do',
        },
        {
          title: 'Final exec sign-off if required',
          type: 'To-do',
        },
        {
          title: 'Publish policy on intranet',
          type: 'To-do',
        },
        {
          title: 'Execute comms plan',
          type: 'To-do',
        },
        {
          title: 'Agree monitoring approach',
          type: 'To-do',
        },
      ],
    },
  ],
  'self-service': [],
  other: [],
};

const getActionTemplate = (type, projectId, userId) => {
  type = type.replace(/ /g, '').toLowerCase();

  models[type].forEach(group => {
    group.projectId = projectId;

    group.actions.forEach(action => {
      action.description = '';
      action.assigneeId = userId;
      action.priority = null;
      action.dueDate = null;
      action.completed = false;
      action.linkedDocs = [];
      action.status = 'Complete';
      action.projectId = projectId;
    });
  });

  return models[type];
};

export default getActionTemplate;
